export default __webpack_public_path__ + "static/media/2019 (2).6816a033.JPG";